<div class="tab-content accordion" id="myTabContent">
  
    <div *ngIf= "activeTab ==='watch' && videos " class="tab-pane fade show active" id="watch-tab-pane" role="tabpanel" aria-labelledby="watch-tab"
      tabindex="0">
      <div class="accordion-body tabOverview_wrap">
        <div class="row row-vw blogs-row" #videoRow>
          <div class="col-lg-4" *ngFor="let video of videos">
            <div class="watchBx">
              <a  target="_blank" class="watchBx-link d-block" (click)="openVideo(video.youtubeLink)">
                <div class="yt-img position-relative mrg-b-15 cursor-pointer">
                  <picture class="w-100 d-block infographic">
                    <source [srcset]="video.imagePath" class="w-100 deskImg image-fit thumbnail-img">
                    <img [src]="video.imagePath" alt="Video Thumbnail" class="w-100 mobImg image-fit thumbnail-img"
                      loading="lazy">
                  </picture>
                  <div class="playIcon">
                    <img src="assets/ITI-IAP-HTML/images/play-icon.png" class="w-100" alt="Play Icon">
                  </div>
                </div>
                <div class="watchTitle f-s-20  line_H_1_2 text-black ltr-space" style="text-align: center">
                  {{ video.title }}
                </div>
              </a>
            </div>
          </div>
        </div>
        <div class="row row-vw" *ngIf="videos.length < videosList.length">
          <div class="col-lg-12">
            <div class="viewAll_wrap mrg-t-50 text-center" (click)="loadMore()" >
              <a class="viewAll_btn f-s-20 font-Baskervville ltr-space"> Load More </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf= "activeTab ==='infographics' && infographics " class="tab-pane fade show active" id="infographics-tab-pane" role="tabpanel" aria-labelledby="infographics-tab"
      tabindex="0">
   
      <div class="accordion-body tabOverview_wrap">
        <div class="row row-vw blogs-row" #infoRow>
          <div class="col-lg-4" *ngFor="let infographic of infographics">
            <div class="watchBx">
              <div class="yt-img position-relative mrg-b-15 cursor-pointer " (click)="openModal(content)">
                <a href="javascript:void(0)" class="watchBx-link d-block infographic" data-bs-toggle="modal"
                  [attr.data-bs-target]="infographic.modalTarget">
                  <picture class="w-100 d-block infographic">
                    <source [srcset]="infographic.thumbnailPath" media="(min-width: 768px)" class="w-100 deskImg image-fit thumbnail-img">
                    <img decoding="async" [src]="infographic.thumbnailPath" [alt]="infographic.thumbnailName"
                      class="w-100 mobImg image-fit thumbnail-img" loading="lazy">
                  </picture>
                </a>
              </div>
              <div class="infoGraph">
                <div class="d-flex justify-content-between align-items-center">
                  <div class="shareBtn_wrap">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <div class="shareBtn line_H_1 text-black f-s-14 d-flex cstgap-2">
                          Share <img src="assets/ITI-IAP-HTML/images/share-icon.svg" class="shareIcon" alt=""
                            loading="lazy">
                        </div>
                      </li>
                      <li class="list-inline-item" *ngFor="let shareIcon of [1, 2, 3, 4]">
                        <a href="javascript:void(0);"
                                  class="shareIcon"
                                  (click)="
                                    redirectToSocialMedia(
                                      shareIcon,
                                      infographic.filePath
                                    )
                          ">
                          <img [src]="'assets/ITI-IAP-HTML/images/share-icon-' + shareIcon + '.svg'"
                            class="w-100" alt="" loading="lazy">
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div class="downloadBtn-wrap">
                    <a href="javascript:void(0);"  class="downloadBtn line_H_1 text-black f-s-14 d-flex cstgap-2" (click)="downloadFile(infographic.filePath)">
                      Download     <file-download [path]="infographic.filePath"></file-download>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <ng-template #content let-modal>
              <div class="closeBtn" (click)="closePopup(modal)">
                <img class="btn-close" src="assets/ITI-IAP-HTML/images/black-close-circle-or-delete-20709.svg"
                  alt="" srcset="">
              </div>
              <div class="infographics-imgSec">
                <picture class="w-100 d-block img-container">
                  <source [srcset]="infographic.filePath" media="(min-width: 768px)" class="w-100 deskImg ">
                  <img decoding="async" [src]="infographic.filePath" [alt]="infographic.fileName"
                    class="w-100 mobImg  img-fixed-height" loading="lazy">
                </picture>
              </div>
              <div class="infoShare">
                <div class="d-flex justify-content-between align-items-center">
                  <div class="shareInfo">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item text-black f-s-14">
                        Share
                      </li>
                      <li class="list-inline-item" (click)="
                      redirectToSocialMedia(
                        1,
                        infographic.filePath
                      )
                    ">
                        <a href="javascript:void(0);" class="infoShare-icon">
                          <img src="assets/ITI-IAP-HTML/images/infoshare-icon-1.svg" class="w-100" alt="" loading="lazy">
                        </a>
                      </li>
                      <li class="list-inline-item"  (click)="
                      redirectToSocialMedia(
                        2,
                        infographic.filePath
                      )
                    ">
                        <a href="javascript:void(0);" class="infoShare-icon">
                          <img src="assets/ITI-IAP-HTML/images/infoshare-icon-2.svg" class="w-100" alt="" loading="lazy">
                        </a>
                      </li>
                      <li class="list-inline-item" (click)="
                      redirectToSocialMedia(
                        3,
                        infographic.filePath
                      )
                    " >
                        <a href="javascript:void(0);" class="infoShare-icon">
                          <img src="assets/ITI-IAP-HTML/images/infoshare-icon-3.svg" class="w-100" alt="" loading="lazy">
                        </a>
                      </li>
                      <li class="list-inline-item" (click)="
                      redirectToSocialMedia(
                        4,
                        infographic.filePath
                      )
                    ">
                        <a href="javascript:void(0);" class="infoShare-icon">
                          <img src="assets/ITI-IAP-HTML/images/infoshare-icon-4.svg" class="w-100" alt="" loading="lazy">
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div class="infoDownload">
                    <a href="javascript:void(0);" class="downloadBtn line_H_1 text-black f-s-14 d-flex cstgap-2" (click)="downloadFile(infographic.filePath)">
                      Download   <file-download [path]="infographic.filePath"></file-download>
                    </a>
                  </div>
                </div>
              </div>
          
            </ng-template>
          </div>
        </div>
        <div class="row row-vw" *ngIf="infographics.length < infographicsList.length">
          <div class="col-lg-12">
            <div class="viewAll_wrap mrg-t-50 text-center" (click)="loadMore()" >
              <a class="viewAll_btn f-s-20 font-Baskervville ltr-space"> Load More </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf= "activeTab ==='read' && reads " class="tab-pane fade show active" id="read-tab-pane" role="tabpanel" aria-labelledby="read-tab" tabindex="0">
      <div class="accordion-body tabOverview_wrap">
        <div class="row row-vw blogs-row" #readRow>
          <div class="col-lg-4" *ngFor="let blog of reads">
            <div class="watchBx">
              <a (click) ="viewBlogPage(blog.id)"class="watchBx-link d-block">
                <div class="yt-img position-relative mrg-b-15 cursor-pointer">
                  <picture class="w-100 d-block infographic">
                    <source [srcset]="blog.imagePath" media="(min-width: 768px)" class="w-100 deskImg image-fit thumbnail-img">
                    <img decoding="async" [src]="blog.imagePath" alt="blog.imageName" class="w-100 mobImg image-fit thumbnail-img" loading="lazy">
                  </picture>
                </div>
                <div
                  class="watchTitle f-s-20 font-Baskervville line_H_1_2 text-black text-decoration-underline ltr-space cursor-pointer" style="text-align: center">
                  {{ blog.title }}
                </div>
              </a>
            </div>
          </div>
        </div>
        <div class="row row-vw" *ngIf="reads.length < readList.length">
          <div class="col-lg-12">
            <div class="viewAll_wrap mrg-t-50 text-center" (click)="loadMore()" >
              <a class="viewAll_btn f-s-20 font-Baskervville ltr-space"> Load More </a>
            </div>
          </div>
        </div>
      </div>
    </div> 
<div class="video-modal" *ngIf="showVideoPopup" (click)="closeVideo()">
  <div class="video-popup-content" 
       [ngClass]="{'full-video': !isShort, 'short-video': isShort}" 
       (click)="$event.stopPropagation()">

    <!-- Spinner -->
    <div *ngIf="loadingVideo" class="video-loading-overlay">
      <div class="spinner"></div>
    </div>

    <div class="video-responsive-wrapper">
      <youtube-player
        [videoId]="videoId"
        (ready)="onPlayerReady($event)">
      </youtube-player>
    </div>

    <button class="close-btn" (click)="closeVideo()">✕</button>
  </div>
</div>

  </div>
